import pluralize from "pluralize";
import { useCallback, useState } from "react";

import { DriveFileFragment } from "@/features/drive/queries.graphql";
import { downloadGLBAsOBJ } from "@/utils/download";

import useShowSnackbar from "../useShowSnackbar";

export const useDownloadFilesAsObj = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { showSuccess, showError } = useShowSnackbar();

  const downloadFilesAsObj = useCallback(
    async (files: DriveFileFragment[]) => {
      setIsLoading(true);

      try {
        await Promise.all(
          files.map(async (file) => {
            await downloadGLBAsOBJ(file);
          }),
        );

        showSuccess(
          `Downloaded ${files.length} ${pluralize("model", files.length)} as OBJ`,
        );
      } catch (error) {
        console.error("Error converting GLB to OBJ:", error);
        showError(
          `Failed to download ${files.length} ${pluralize("model", files.length)} as OBJ`,
        );
      } finally {
        setIsLoading(false);
      }
    },
    [showError, showSuccess],
  );

  return {
    downloadFilesAsObj,
    isLoading,
  };
};
